import { Avatar } from '@socialchorus/shared-ui-components';
import { Link } from '../ui';
import {
  getCommentDisplayAuthor,
  useCommentAuthorLink,
} from '../../models/comments/helpers';
import { Comment } from '../../models/comments/types';

type CommentAuthorAvatarProps = {
  comment: Comment;
  onClick: () => void;
};

const CommentAuthorAvatar = ({
  comment,
  onClick,
}: CommentAuthorAvatarProps) => {
  const { avatar } = getCommentDisplayAuthor(comment);
  const href = useCommentAuthorLink(comment);

  const image = (
    <Avatar size="medium" shape="circle" imgSrc={avatar.url || undefined} />
  );

  return href ? (
    <Link
      href={href}
      action="push"
      className="comment-author-avatar"
      onClick={onClick}
      aria-label="Profile"
    >
      {image}
    </Link>
  ) : (
    <div className="comment-author-avatar">{image}</div>
  );
};

export default CommentAuthorAvatar;
